import { FC, useCallback, useEffect } from 'react';
import { Form } from 'react-final-form';

import { Panel } from 'src/components/Panel/Panel';
import { savePlace } from 'src/store/admin/services';
import { adminActions } from 'src/store/admin/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { Room } from 'src/types';

import { Actions } from './Actions';
import { RoomFields } from './Fields/RoomFields';

export interface RoomSidesheetProps {
  bookingObject: Room;
}

export const RoomSidesheet: FC<RoomSidesheetProps> = ({ bookingObject }) => {
  const dispatch = useAppDispatch();

  const save = useCallback(async () => {
    await dispatch(savePlace());
    return true;
  }, [dispatch]);

  const handleKeydown = useCallback(
    (event: KeyboardEvent) => {
      type ArrowKey = 'ArrowLeft' | 'ArrowRight' | 'ArrowUp' | 'ArrowDown';

      const arrows = new Set<ArrowKey | string>([
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
      ]);

      const moveHandlers: Record<ArrowKey, () => void> = {
        ArrowLeft: () => {
          dispatch(adminActions.moveLeft());
        },
        ArrowRight: () => {
          dispatch(adminActions.moveRight());
        },
        ArrowUp: () => {
          dispatch(adminActions.moveUp());
        },
        ArrowDown: () => {
          dispatch(adminActions.moveDown());
        },
      };

      if (arrows.has(event.key)) {
        const key = event.key as ArrowKey;
        moveHandlers[key]();
      }
    },
    [dispatch],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeydown);

    return () => {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [handleKeydown]);

  return (
    <Form onSubmit={save} initialValues={bookingObject}>
      {() => (
        <Panel
          actions={<Actions existing={!!bookingObject.id} />}
          testId='administratorSidesheetPanel'
        >
          <RoomFields bookingObject={bookingObject} />
        </Panel>
      )}
    </Form>
  );
};
